import React from "react";
import { inject } from "mobx-react";
import TariffOrderBlock from "../TariffOrderBlock/TariffOrderBlock";

const TariffOrder = (props) => {
	const text = props.ApplicationModel.text;
	return <TariffOrderBlock {...props} text={text} />;
};

export default inject("ApplicationModel")(TariffOrder);
